import z from 'zod';

import { AccessoryListItemDtoSchema } from './AccessoryListItemDto';
import { AccessoryListItemDto } from './AccessoryListItemDto';
import { DecimalRangeSchema } from './DecimalRange';
import { DecimalRange } from './DecimalRange';
import { DoubleRangeSchema } from './DoubleRange';
import { DoubleRange } from './DoubleRange';

export type GetAccessoryBySearchParamsResponseModel = {
	data: AccessoryListItemDto[];
	pageIndex: number;
	pageSize: number;
	totalCount: number;
	totalPages: number;
	hasPreviousPage: boolean;
	hasNextPage: boolean;
	minMaxPriceRange: DecimalRange;
	currencyCode: string | null;
	minMaxCarbonDioxideRange: DoubleRange;
};

export const GetAccessoryBySearchParamsResponseModelSchema: z.ZodType<GetAccessoryBySearchParamsResponseModel> =
	z.object({
		data: z.lazy(() => AccessoryListItemDtoSchema).array(),
		pageIndex: z.number(),
		pageSize: z.number(),
		totalCount: z.number(),
		totalPages: z.number(),
		hasPreviousPage: z.boolean(),
		hasNextPage: z.boolean(),
		minMaxPriceRange: z.lazy(() => DecimalRangeSchema),
		currencyCode: z.string().nullable(),
		minMaxCarbonDioxideRange: z.lazy(() => DoubleRangeSchema),
	});
